angular.module( 'angus.directives' ).directive( 'santaPriorPeriodVar', [
    'actionViewTemplates',
    function(actionViewTemplates) {
        return {
            scope: {
                model      : "=actionModel",
                settings   : "=santaPriorPeriodVarWidgetSettings",
                widgetCode : "="
            },
            templateUrl: actionViewTemplates.santaPriorPeriodVarContainer
        };
    }
] );